import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';


@Injectable( {
    providedIn: 'root'
} )
export class AuthGuard implements CanActivate {
    constructor( private accountService: AccountService,     
        private router: Router ) {}

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if ( this.accountService.getAccount().email.trim() != "" ) {
            return true;
        } else {
            this.router.navigate( ['/'] );
        }
        return false;
    }
}
